export enum Channel {
    online = 'ONLINE',
    cash = 'CASH',
    bank_transfer='BANK_TRANSFER',
    pos='POS',
    ar="AR",
    box_office='BOX_OFFICE'
  }
  